// extracted by mini-css-extract-plugin
module.exports = {"menu":"menu_Hzgzu","right":"right_dcEPh","action":"action_-zjI5","search":"search_zsa4r","account":"account_hTsST","avatar":"avatar_ACeUt","dark":"dark_D4uFF"};